import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ModalService } from '../../../base/shared/modal/modal.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { CategoryDTO, CreateCategoryDTO, UpdateCategoryDTO, FilterDTO, FilterOperator, SortDirection } from '../../../base/models/models.swagger.generated';
import { CategoryFormType } from './category-edit-form';
import { PagedQueryModel } from '../../../base/shared/table/paged-query-model';
import { FilterMap } from '../../../base/shared/table/filter-map';
import { FilterMetadata } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CategoryService } from './category.service';
import { AppErrorMessagesComponent } from '../../../base/error-messages/app-error-messages.component';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';


@Component({
  selector: 'app-category',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    TableModule,
    TranslateModule,
    AppErrorMessagesComponent,
    SearchFieldComponent,
    CommonModule

  ],
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  providers: [CategoryService]
})
export class CategoryComponent implements OnInit, OnDestroy {

  public data: CategoryDTO[] = [];
  public totalNoOfRecords: number = 0;
  public category: CategoryDTO;
  public itemDialog: boolean = false;
  public pagedQuery: PagedQueryModel = PagedQueryModel.getDefault();
  public form: FormGroup<CategoryFormType>;
  public globalFilters = ['id', 'category'];
  public columnFilters: { [key: string]: FilterMetadata | FilterMetadata[] } = {};
  private _subscription: Subscription = new Subscription();
  private searchText: string = '';




  constructor(
    private CategoryService: CategoryService,
    private router: Router,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private modalService: ModalService

  ) { }
  ngOnInit() {
    this.loadData();
  }

  public get filterMatchModeOptions() {
    return FilterMap.getStringFilterMatchModeOptions();
  }

  private loadData() {
    this._subscription.add(
      this.CategoryService.getData(this.pagedQuery).subscribe((data) => {
        this.data = data.items;
        this.totalNoOfRecords = data.totalNumberOfItems;
        this.category = null;
        this.itemDialog = false;
      })
    );
  }

  private getFilters(): FilterDTO[] {
    const filters: FilterDTO[] = [];
    const addFilter = (field: string, operator: FilterOperator, value: any) => {
      filters.push(new FilterDTO({ field, operator, value, isComplex: false }));
    };

    if (this.searchText) {
      addFilter('name', FilterOperator.Contains, this.searchText);
    }

    Object.entries(this.columnFilters).forEach(([key, filter]) => {
      if (Array.isArray(filter)) {
        filter.forEach(f => f.value && addFilter(key, FilterMap.getFilterOperator(f.matchMode), f.value));
      } else if (filter?.value) {
        addFilter(key, FilterMap.getFilterOperator(filter.matchMode), filter.value);
      }
    });
    return filters;
  }

  public onFilter(event: any) {
    this.columnFilters = event.filters;
    this.pagedQuery.filters = this.getFilters();
    this.loadData();
  }

  public openNew() {
    this.category = null;
    this.initForm();
    this.itemDialog = true;
  }

  public editItem(item: CategoryDTO) {
    this.category = new CategoryDTO(item);
    this.initForm();
    this.itemDialog = true;
  }

  public deleteCategory(category: CategoryDTO) {
    const dialog = this.modalService.showOkCancelDialog(
      'i18n.domain.category.messages.delete-confirm-title',
      'i18n.domain.category.messages.delete-confirm'
    );

    dialog.onOkSubject.subscribe(() => {
      this._subscription.add(
        this.CategoryService.deleteRecord(category.categoryId).subscribe(() => {
          this.loadData();
        })
      );
    });
  }

  public hideDialog() {
    this.itemDialog = false;
  }

  public saveCategory() {
    if (this.form.valid) {
      const categoryData = this.form.value;
      if (categoryData.Id) {
        const updateDto = new UpdateCategoryDTO({
          categoryId: categoryData.Id,
          name: categoryData.name

        });


        this._subscription.add(
          this.CategoryService.updateRecord(updateDto).subscribe(() => {
            this.loadData();
          })
        );
      } else {
        this._subscription.add(
          this.CategoryService.addRecord(categoryData as CreateCategoryDTO).subscribe(() => {
            this.loadData();
          })
        );
      }
    }
  }

  public onPageChange(event: any) {
    this.pagedQuery.skip = event.first;
    this.pagedQuery.take = event.rows;
    this.loadData();
  }

  public onSearchTextChanged(searchText: string) {
    this.searchText = searchText;
    const filters = this.getFilters();
    console.log('Search Text:', searchText);
    console.log('Generated Filters:', filters);
    this.pagedQuery.filters = filters;
    this.pagedQuery.skip = 0;
    this.loadData();
  }

  public onSort(event: any) {
    this.pagedQuery.sortBy = event.field;
    this.pagedQuery.sortDirection = event.order === 1 ? SortDirection.Ascending : SortDirection.Descending;
    this.loadData();
  }

  private initForm() {
    const { categoryId, name } = this.category || {};
    this.form = this.fb.group<CategoryFormType>({
      Id: this.fb.control<number>(categoryId),
      name: this.fb.control<string>(name || '',[ Validators.required, Validators.maxLength(50)]),
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}


